// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__13rKT","footer":"ChangeClinic_footer__2HoXT"};